/* eslint-disable no-undef */
/* global google */
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import invariant from 'invariant'

import GoogleMapsWrapper from './GoogleMapsWrapper'
import { Marker } from 'react-google-maps'
import OverlayView from 'react-google-maps/lib/components/OverlayView'
import MarkerClusterer from 'react-google-maps/lib/components/addons/MarkerClusterer'
// import MarkerWithLabel from 'react-google-maps/lib/components/addons/MarkerWithLabel'
import { OVERLAY_VIEW } from 'react-google-maps/lib/constants'

import moment from 'moment'

import { iconMapper, iconMapperPremium } from './../utils/utilities'
import Icon from './Icon'
import clusterImg from './styles/assets/mapnode-cluster.svg'
import clusterImgPremium from './styles/assets/mapnode-cluster-premium.png'
import laraschImg from './styles/assets/larasch-logo-light.svg'

import { isEmbedded, setVisibleEvents } from './actionsReducers'

import './styles/Map.css'

class CustomOverlayView extends OverlayView {
  // Override draw function to catch errors with map panes being undefined to prevent console errors
  draw() {
    const { mapPaneName } = this.props
    invariant(!!mapPaneName, `OverlayView requires either props.mapPaneName or props.defaultMapPaneName but got %s`, mapPaneName)
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
    const mapPanes = this.state[OVERLAY_VIEW].getPanes()
    if (!!mapPanes && !!this.containerElement) {
      // <-- Add conditional to ensure panes and container exist before drawing
      mapPanes[mapPaneName].appendChild(this.containerElement)

      ReactDOM.unstable_renderSubtreeIntoContainer(
        this,
        React.Children.only(this.props.children),
        this.containerElement,
        this.onPositionElement
      )
    }
  }

  onRemove() {
    if (!!this.containerElement) {
      super.onRemove()
    }
  }
}

export class Map extends Component {
  constructor(props) {
    super(props)
    this.state = {
      map: false,
      popupHovered: false,
      popupContent: null,
      boundsHandlerTimeout: null,
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this._fitToMapboundsMulti(this.props.events.items)
    }, 500)
  }

  _fitToMapboundsMulti = (items) => {
    if (items.length > 0) {
      const {map} = this.state
      let bounds = new google.maps.LatLngBounds()
      for (var i = 0; i < items.length; i++) {
        bounds.extend({ lat: items[i].latitude, lng: items[i].longitude })
      }
      map.fitBounds(bounds, 100)
    }
  }

  // MAP POSITION
  _handleMapMount = (map) => {
    this.setState({
      map,
    })
  }

  _handlePopupOpen = (markerCon) => {
    if (!markerCon) {
      console.log('CLOSE')
      this.setState({
        popupHovered: false,
        popupContent: null,
      })
      return
    }

    console.log('TOGGLE')
    const {popupHovered} = this.state
    const sameMarker = popupHovered === markerCon.id
    const newHovered = !popupHovered || !sameMarker
    this.setState({
      popupHovered: newHovered ? markerCon.id : false,
      popupContent: newHovered ? markerCon : null,
    })
  }

  _getPixelOffset = () => {
    let isMobile = window.innerWidth <= 550 ? true : false
    if (isMobile) {
      return {
        x: -window.innerWidth / 2.5,
        y: 20
      }
    }
    return {
      x: -190,
      y: 20
    }
  }

  _handleBoundsChange = (e) => {
    const { dispatch } = this.props
    const { boundsHandlerTimeout, map } = this.state
    if (!!boundsHandlerTimeout) {
      clearTimeout(boundsHandlerTimeout)
    }
    this.setState({
      boundsHandlerTimeout: setTimeout(() => {
        const bounds = map.getBounds()
        const visibleEvents = this.props.events.items
        .filter(item => bounds.contains(new google.maps.LatLng(item.latitude, item.longitude)))
        .map(item => item.id)
        dispatch(setVisibleEvents(this.props.events.items, visibleEvents))
      }, 500)
    })
  }

  _clusteringEnded = (e) => {
    let clusters = e.clusters_
    if (clusters.length > 0) {
      for (let i = 0; i < clusters.length; i++) {
        let prem = false
        for (let j = 0; j < clusters[i].markers_.length; j++) {
          if (clusters[i].markers_[j].premium === true) {
            prem = true;
            break;
          }
        }
        if (prem) {
          clusters[i].clusterIcon_.url_ = clusterImgPremium
        }
        else {
          clusters[i].clusterIcon_.url_ = clusterImg
        }
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const thisEventCount = this.props.events.items.length
    const nextEventCount = nextProps.events.items.length
    const thisPopup = this.state.popupHovered
    const nextPopup = nextState.popupHovered

    const hasEvents = nextEventCount >= 0
    const changedEvents = thisEventCount !== nextEventCount
    const changedPopup = thisPopup !== nextPopup

    const doUpdate = hasEvents && (changedEvents || changedPopup)

    if (doUpdate && !changedPopup) {
      setTimeout(() => {
        this._fitToMapboundsMulti(nextProps.events.items)
      }, 500)
    }
    return doUpdate
  }

  render() {
    let popupContent = this.state.popupContent

    var Markers = this.props.events.items.map((marker) => {
      return (
        <Marker
          key={marker.id}
          className="marker-custom"
          position={{ lat: marker.latitude, lng: marker.longitude }}
          icon={
            marker.premium
              ? {
                  url: iconMapperPremium(marker.mapIconSport),
                  scaledSize: { width: 48, height: 48 },
                  size: { width: 45, height: 55 },
                  anchor: { x: 22, y: 45 },
                  origin: { x: 0, y: 0 }
                }
              : {
                  url: iconMapper(marker.mapIconSport),
                  scaledSize: { width: 48, height: 48 },
                  size: { width: 45, height: 55 },
                  anchor: { x: 22, y: 45 },
                  origin: { x: 0, y: 0 }
                }
          }
          options={
            {
              zIndex: 10,
              premium: marker.premium,
            }
          }
          onClick={() => this._handlePopupOpen(marker)}
        />
      )
    })

    let mapZoom = this.props.mapViewport.zoom
    // let mapCenter = { lat: this.props.mapViewport.center[0], lng: this.props.mapViewport.center[1] }
    let mapCenter = this.props.mapViewport.center

    let dateRange = ''
    if (!!popupContent) {
      const fY = moment(popupContent['date-from']).format('YYYY')
      const fM = moment(popupContent['date-from']).format('MM') + '.'
      const fD = moment(popupContent['date-from']).format('DD') + '.'
  
      const tY = moment(popupContent['date-to']).format('YYYY')
      const tM = moment(popupContent['date-to']).format('MM') + '.'
      const tD = moment(popupContent['date-to']).format('DD') + '.'
  
      const sameYear = fY === tY
      const sameMonth = fM === tM
      const sameDay = fD === tD
  
      if (sameDay && sameMonth && sameYear) {
        dateRange = fD + fM + fY
      }
      else if (!sameDay && sameMonth && sameYear) {
        dateRange = fD + '-' + tD + tM + tY
      }
      else if (!sameMonth && sameYear) {
        dateRange = fD + fM + '-' + tD + tM + tY
      }
      else {
        dateRange = fD + fM + fY + '-' + tD + tM + tY
      }
    }

    return (
      <div style={{ width: '100%', height: '100vh', zIndex: '0' }}>
        <GoogleMapsWrapper
          googleMapURL={globalGMAPSurl}
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div id="mapContainer"  className={ isEmbedded() ? ' isEmbedded' : '' } />}
          mapElement={<div style={{ height: `100%`, width: `100%` }} />}
          center={mapCenter}
          zoom={mapZoom}
          defaultMapTypeId={globalDefaultMapType}
          defaultOptions={globalDefaultMapOptions}
          onMapMounted={this._handleMapMount}
          onBoundsChanged={this._handleBoundsChange}
        >
          <span>
            {!!this.state.popupHovered && (
              <CustomOverlayView
                position={{ lat: popupContent.latitude, lng: popupContent.longitude }}
                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                getPixelPositionOffset={this._getPixelOffset}
                >
                <div
                  className="leaflet-popup"
                >
                  {
                    !!this.state.popupHovered &&
                    <div className="leaflet-dimmer leaflet-dimmer-tl" onClick={() => this._handlePopupOpen(false)} />
                  }
                  {
                    !!this.state.popupHovered &&
                    <div className="leaflet-dimmer leaflet-dimmer-tr" onClick={() => this._handlePopupOpen(false)} />
                  }
                  {
                    !!this.state.popupHovered &&
                    <div className="leaflet-dimmer leaflet-dimmer-br" onClick={() => this._handlePopupOpen(false)} />
                  }
                  {
                    !!this.state.popupHovered &&
                    <div className="leaflet-dimmer leaflet-dimmer-bl" onClick={() => this._handlePopupOpen(false)} />
                  }
                  <div
                    className="flex flex-col rounded shadow bg-white w-screen-80vw max-w-24rem px-8 pt-2 pb-4 text-base hover-group"
                    onClick={() => window.open('https://' + popupContent['event-url'], '_top')}
                  >
                    <div className="flex flex-row justify-start items-center">
                      <div className="flex-scale font-bold text-lg">
                        { popupContent.name }
                      </div>
                      <div className="flex-no-scale pl-4">
                        <Icon name={ this.props.sportsType } size="50" color="#649ed6" />
                      </div>
                    </div>
                    <div className="flex flex-row">
                      <div className="flex flex-col flex-scale">
                        <div>{ dateRange }</div>
                        <div className="mb-4">{ popupContent.location }</div>
                        <div>{ popupContent.contests } { popupContent.contests === 1 ? 'Wettkampf' : 'Wettkämpfe' }</div>
                        <div>({ popupContent.courses })</div>
                      </div>
                      <div className="flex flex-col flex-no-scale">
                        <div className="flex-scale">
                          {
                            popupContent.premium &&
                            <div className="rounded-full px-4 py-2 bg-yellow text-xs text-center">
                              PREMIUM
                            </div>
                          }
                        </div>
                        <div className="flex-no-scale flex items-center">
                          <div className="bg-blue skew px-4 py-2 hover-border">
                            <div className="font-bold text-white unskew">
                              Mehr Infos
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-center items-center">
                    <div className="leaflet-logo w-1of4 mx-auto bg-white skew">
                      <div className="unskew">
                        <img src={laraschImg} alt="larasch.de" className="w-full" />
                      </div>
                    </div>
                  </div>
                </div>
              </CustomOverlayView>
            )}
            <MarkerClusterer
              key={Math.random()}
              {...globalDefaultClusterOptions}
              onClusteringEnd={e => this._clusteringEnded(e)}
            >
              {Markers}
            </MarkerClusterer>
          </span>
        </GoogleMapsWrapper>
      </div>
    )
  }
}

export default Map



// WEBPACK FOOTER //
// ./src/components/Map.js